<template>
  <div>
    <div v-if="false" class="floating-right" @click="setShowContactUsPanel()" @mouseleave="hoverContactUsPanel()" @focusout="hideShowContactUsPanel()" tabindex="0">
      <div @mouseenter="hoverContactUsPanel()" class="floating-button">{{ $t(`label.contactUs`) }}</div>
      <div v-if="showRewardPanel" class="contactUs-panel d-flex flex-column align-center justify-center">
        <div class="contactUs-header d-flex justify-space-around align-center">
          <div><img loading="lazy" class="contactUs-header-icon" src="/static/svg/layout/customer-support.svg" alt="contactUs icon" /></div>
          <div>{{ $t(`floating.contactUsHeader`) }}</div>
        </div>
        <a href="https://t.me/bhai88_official" target="_blank" rel="nofollow" class="contactUs-item telegram-item d-flex align-center">
          <img loading="lazy" class="contactUs-icon" :src="`/static/svg/layout/telegram.svg`" alt="telegram support" />
          <div>Bhai88</div>
        </a>
        <a href="mailto:support@bhai88.org" rel="nofollow" target="_blank" class="contactUs-item email-item d-flex align-center">
          <img loading="lazy" class="contactUs-icon" :src="`/static/svg/layout/email.svg`" alt="email support" />
          <div>support@bhai88.com</div>
        </a>
        <a href="javascript:void(0);" @click="showIntercomLC" rel="nofollow" class="contactUs-item livechat-item d-flex align-center">
          <img loading="lazy" class="contactUs-icon" :src="`/static/svg/layout/live-chat.svg`" alt="livechat support" />
          <div>{{ $t(`label.customerService`) }}</div>
        </a>
      </div>
    </div>
    <!--      <div v-if="$vuetify.breakpoint.smAndDown" class="fab-goUp">-->
    <!--        <div v-if="moreContactUs" class="d-flex flex-column">-->
    <!--          <a href="https://direct.lc.chat/13536354/" rel="nofollow" target="_blank" class="mx-auto">-->
    <!--            <img loading="lazy" class="mobile-livechat-icon " src="/static/svg/layout/goUp.svg" alt="livechat"/>-->
    <!--          </a>-->
    <!--        </div>-->
    <!--      </div>-->
    <img @click="navigateToVoucherPage()" src="/static/image/icon/Reward_Icon.png" class="rewards_icon_home_page" :class="moreContactUs ? 'rewards_icon_home_page_go_up' : 'rewards_icon_home_page'" />
    <div class="fab-contactUs">
      <div v-if="moreContactUs" class="d-flex flex-column">
        <a href="javascript:void(0);" @click="showIntercomLC" rel="nofollow" class="mx-auto">
          <img loading="lazy" class="mobile-livechat-icon " src="static/svg/layout/Livechat_Icon.png" alt="livechat" />
        </a>
        <a href="https://t.me/bhai88_official" rel="nofollow" target="_blank">
          <img loading="lazy" class="contactUs-icon" src="/static/svg/layout/telegram-mobile.png" alt="telegram" />
        </a>
        <a href="mailto:support@bhai88.com" rel="nofollow" target="_blank">
          <img loading="lazy" class="contactUs-icon" src="/static/svg/layout/email-mobile.png" alt="email" />
        </a>
      </div>
      <div @click="setMoreContactUs()" class="contactUs-icon">
        <!--              <img loading="lazy" class="reward-icon" src="static/svg/homepage/Livechat_Icon.png"   />-->
        <img loading="lazy" class="contactUs-icon" :src="moreContactUs ? `/static/svg/layout/cancel-mobile.png` : `static/svg/layout/Livechat_Icon.png`" height="52" width="52" alt="reward icon" />
      </div>
    </div>
  </div>
</template>

<script>
import { uiHelper, locale } from '@/util'
import i18n from '@/plugins/i18n'
import { ROUTE_NAME } from '@/constants/route.constants'
import { DevicePlatform } from '@/constants/enums'

export default {
  name: 'floatingContactUs',
  props: {},
  data: () => ({
    i18n,
    showRewardPanel: false,
    active: false,
    moreContactUs: false,
    showButton: true
  }),
  methods: {
    navigateToVoucherPage() {
      if (!this.isLoggedIn) {
        return this.$parent.openLoginDialog()
      }
      this.$router.push({
        name: ROUTE_NAME.CLAIM_VOUCHER,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    showIntercomLC() {
      Intercom('show')
      return false
    },
    hoverContactUsPanel() {
      if (!this.active) this.showRewardPanel = !this.showRewardPanel
    },
    setShowContactUsPanel() {
      if (!this.active && this.showRewardPanel) {
        this.active = true
        this.showRewardPanel = true
      } else {
        this.active = !this.active
        this.showRewardPanel = !this.showRewardPanel
      }
    },
    hideShowContactUsPanel() {
      this.active = false
      this.showRewardPanel = false
    },
    setMoreContactUs() {
      this.moreContactUs = !this.moreContactUs
    },
    openLiveChat() {
      this.$parent.openLiveChat()
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      let lvlwrapper = document.getElementsByClassName('vipwrapper')[0]
      if (lvlwrapper) {
        lvlwrapper.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    }
  }
}
</script>

<style lang="scss">
.rewards_icon_home_page {
  animation: beat 1s infinite alternate;
  width: 52px;
  height: auto;
  z-index: 10;
  position: fixed;
  right: 18px;
  bottom: 19%;
}
.rewards_icon_home_page_go_up {
  bottom: 38%;
}
.fab-contactUs {
  position: fixed;
  bottom: 8%;
  right: 18px;
  z-index: 5;
  text-decoration: none;

  .goUp-icon {
    width: 72px;
    height: 72px;
    cursor: pointer;
  }

  .fab-goUp {
    position: fixed;
    bottom: 150px;
    right: 20px;
    bottom: 12%;
    right: 0;
    z-index: 5;
    text-decoration: none;
  }
  .contactUs-icon {
    width: 52px !important;
    height: 52px !important;
    cursor: pointer;
  }

  .mobile-livechat-icon {
    width: 52px !important;
    height: 52px !important;
    cursor: pointer;
  }
}

.floating-right {
  position: fixed;
  display: flex;
  z-index: 5;
  right: 0;
  top: calc(50%);

  &:focus {
    &::after {
      width: 100%;
      height: 100%;
      display: absolute;
      z-index: 4;
      background-color: rgba(0, 0, 0, 0.65);
    }
  }

  .floating-button {
    //height: 230px;
    background-image: linear-gradient(to bottom, #0047ff 0%, #5a00b4 100%);
    color: #ffffff;
    text-align: center;
    text-transform: uppercase;
    writing-mode: vertical-lr;
    text-orientation: mixed;
    transform: rotate(180deg);
    padding: 12px 8px;
    top: 0;
    cursor: pointer;
  }

  .contactUs-panel {
    background-color: #f5f5f5;

    .contactUs-header {
      font-size: 1em;
      max-width: 212px;
      text-align: center;
      padding: 0px 12px;

      .contactUs-header-icon {
        width: 80px;
        height: 80px;
      }
    }

    .contactUs-item {
      width: 100%;
      padding: 8px;
      gap: 8px;
      text-decoration: none;
      cursor: pointer;

      .contactUs-icon {
        width: 32px;
        height: 32px;
      }
    }

    .livechat-item {
      background-image: linear-gradient(#f48020, #f05724);
      color: #ffffff;
    }

    .telegram-item {
      background-image: linear-gradient(#45b4e4, #0092c8);
      color: #ffffff;
    }

    .email-item {
      background-image: linear-gradient(#70c59e, #368f6b);
      color: #ffffff;
    }
  }
}

@media screen and (max-width: 959px) {
  .rewards_icon_home_page_go_up {
    bottom: 36%;
  }
}
@media screen and (max-width: 550px) {
  .rewards_icon_home_page {
    bottom: 17.5%;
  }
  .rewards_icon_home_page_go_up {
    bottom: 45%;
  }
}
</style>
